import initSelectCustom from '@ui/SelectCustom/component'

export default function (): void {
  const form = document.getElementById('filter-offers') as HTMLFormElement | null

  const sidebarDetailsEl = document.querySelector<HTMLDetailsElement>('.sidebar .sort-form details.o-select-custom')
  const headerDetailsEl = document.querySelector<HTMLDetailsElement>('.results__header .sort-form details.o-select-custom')

  if (!form || !sidebarDetailsEl || !headerDetailsEl) {
    return
  }

  initSelectCustom(sidebarDetailsEl)
  initSelectCustom(headerDetailsEl)

  const sidebarSelectEl = sidebarDetailsEl.querySelector('select')
  const headerSelectEl = headerDetailsEl.querySelector('select')

  if (!sidebarSelectEl || !headerSelectEl) {
    return
  }

  sidebarSelectEl.addEventListener('change', function () {
    form.submit()
  })

  headerSelectEl.addEventListener('change', function (this: HTMLSelectElement) {
    sidebarSelectEl.value = this.value
    form.submit()
  })
}
